import React from "react";
import AntdModal from "../../../../components/common/AntdModal";
import { useBeneficiariesStore } from "../../../../config/stores";
import AntdTable from "../../../../components/common/AntdTable";
import dayjs from "dayjs";

const BeneficiaryDetails = () => {
  const beneficiariesStore = useBeneficiariesStore();
  const { beneficiaryDetails } = beneficiariesStore;

  const closeModal = () => {
    beneficiariesStore.setShowViewBeneficiaryDetails(false);
  };
  return (
    <AntdModal
      open={beneficiariesStore.showBeneficiaryDetails}
      title={"BENEFICIARY DETAILS"}
      footer={null}
      closeModal={closeModal}
    >
      <AntdTable
        showHeader={false}
        title={() => (
          <span className="fw-bold text-uppercase">
            {beneficiaryDetails?.name}
          </span>
        )}
        bordered={false}
        columns={[
          {
            dataIndex: "title",
          },
          {
            dataIndex: "value",
            render: (value) => <span className="fw-bold">{value}</span>,
          },
        ]}
        data={[
          {
            key: 1,
            title: "Name",
            value: beneficiaryDetails?.name,
          },
          {
            key: 2,
            title: "Project",
            value: beneficiaryDetails?.project?.name,
          },
          {
            key: 3,
            title: "Gender",
            value: beneficiaryDetails?.gender,
          },
          {
            key: 4,
            title: "Age Category",
            value: beneficiaryDetails?.age_category || "N/A",
          },
          {
            key: 5,
            title: "Year Enrolled",
            value: beneficiaryDetails?.year_enrolled || "N/A",
          },
          {
            key: 6,
            title: "Nationality",
            value: beneficiaryDetails?.nationality,
          },
          {
            key: 7,
            title: "Contact",
            value: beneficiaryDetails?.contact || "N/A",
          },
          {
            key: 8,
            title: "Location",
            value: beneficiaryDetails?.location || "N/A",
          },
          {
            key: 9,
            title: "Disability Status",
            value: beneficiaryDetails?.disability_status ? "Yes" : "No",
          },
          {
            key: 10,
            title: "Notes",
            value: beneficiaryDetails?.notes || "N/A",
          },
          {
            key: 11,
            title: "Created By",
            value: `${beneficiaryDetails?.created_by?.first_name || ""} ${
              beneficiaryDetails?.created_by?.other_names || ""
            }`,
          },
          {
            key: 11,
            title: "Created At",
            value: dayjs(beneficiaryDetails?.created_at).format(
              "DD/MM/YYYY HH:mm"
            ),
          },
          {
            key: 12,
            title: "Updated By",
            value: beneficiaryDetails?.updated_by
              ? `${beneficiaryDetails?.updated_by?.first_name || ""} ${
                  beneficiaryDetails?.updated_by?.other_names || ""
                }`
              : "N/A",
          },
          {
            key: 13,
            title: "Updated At",
            value: beneficiaryDetails?.updated_at
              ? dayjs(beneficiaryDetails?.updated_at).format(
                  "DD/MM/YYYY HH:mm"
                )
              : "N/A",
          },
        ]}
      />
    </AntdModal>
  );
};

export default BeneficiaryDetails;

